<template>
  <span class="mx-auto">{{ status }}</span>
</template>

<script>
import { StatusAPI } from "@/lib/api"

export default {
  data: function() {
    return { status: "juliett not responding..." }
  },
  created() {
    StatusAPI.get().then(response => {
      this.status = `${response.branch} ${response.sha} ${response.environment}`
    })
  }
}
</script>

<style lang="css" scoped>
.footer-status {
  padding: 1px 16px;
  text-align: center;
}
</style>
